module.exports = __webpack_public_path__ + "img/vjs-datatable-font-icons.5f8323ac.svg";